import Phaser from 'phaser'

const DEADZONE_X_START = 5
const DEADZONE_X_END = 30

const MOVE_SENSOR_IMG_POS_X = 1000
const MOVE_SENSOR_IMG_POS_Y = 300
const MOVE_SENSOR_IMG_POS_W = 900
const MOVE_SENSOR_IMG_POS_H = 900
const CONTROLLER_IMG_POS_X = 1000
const CONTROLLER_IMG_POS_Y = 400

export default class TouchInput extends Phaser.GameObjects.Container {
  /**
     * @param {Phaser.Scene} scene
     * @param {Player} player
     */
  constructor (scene, player) {
    super(scene)
    this.player = player

    this.triedFullscreen = false

    this.spaceInput = this.scene.add.image(0, 350, 'white')
    this.spaceInput.setSize(400, 800)
    this.spaceInput.setDisplaySize(800, 800)
    this.spaceInput.setDepth(1000)
    this.spaceInput.setVisible(false)
    this.spaceInput.setInteractive()
    this.spaceInput.input.alwaysEnabled = true
    this.spaceInput.on('pointerdown', (pointer, localX, localY, event) => {
      if (!this.triedFullscreen && !this.scene.game.device.os.desktop) {
        this.scene.scale.startFullscreen()
        this.triedFullscreen = true
      }

      if (localX < 1 && localY < 1) {
        this.player.keySpace.isDown = true
        this.player.keySpace.isUp = false
        this.spaceImg.x = (this.spaceInput.x - this.spaceInput.width / 2) + (localX * this.spaceInput.width)
        this.spaceImg.y = (this.spaceInput.y - this.spaceInput.height / 2) + (localY * this.spaceInput.height)
        this.spaceImg.setAlpha(1)
      }
    })
    this.spaceInput.on('pointerup', (pointer, localX, localY, event) => {
      this.player.keySpace.isDown = false
      this.player.keySpace.isUp = true
      this.spaceImg.x = 280
      this.spaceImg.y = CONTROLLER_IMG_POS_Y
      this.spaceImg.setAlpha(0.8)
    })

    this.mouseOrigin = new Phaser.Math.Vector2()
    this.move = new Phaser.Math.Vector2()
    this.prevMove = new Phaser.Math.Vector2()
    this.mouse = new Phaser.Math.Vector2()
    this.isMouseDown = false

    this.controllerImg = this.scene.add.image(CONTROLLER_IMG_POS_X, CONTROLLER_IMG_POS_Y, 'hud', 'shadedLight01')
    this.controllerImg.setSize(100, 100)
    this.controllerImg.setDisplaySize(100, 100)
    this.controllerImg.setDepth(1002)
    this.controllerImg.setAlpha(0.8)

    this.spaceImg = this.scene.add.image(280, CONTROLLER_IMG_POS_Y, 'hud', 'shadedLight26')
    this.spaceImg.setSize(100, 100)
    this.spaceImg.setDisplaySize(100, 100)
    this.spaceImg.setDepth(1002)
    this.spaceImg.setAlpha(0.8)

    this.moveSensorImg = this.scene.add.image(MOVE_SENSOR_IMG_POS_X, MOVE_SENSOR_IMG_POS_Y, 'white')
    this.moveSensorImg.setSize(MOVE_SENSOR_IMG_POS_W, MOVE_SENSOR_IMG_POS_H)
    this.moveSensorImg.setDisplaySize(MOVE_SENSOR_IMG_POS_W, MOVE_SENSOR_IMG_POS_H)
    this.moveSensorImg.setDepth(1000)
    this.moveSensorImg.setVisible(false)
    this.moveSensorImg.setInteractive()
    this.moveSensorImg.input.alwaysEnabled = true

    this.moveSensorImg.on('pointerdown', (pointer, localX, localY, event) => {
      if (!this.triedFullscreen && !this.scene.game.device.os.desktop) {
        this.scene.scale.startFullscreen()
        this.triedFullscreen = true
      }

      this.mouse.x = this.toWorldX(localX)
      this.mouse.y = this.toWorldY(localY)

      this.mouseOrigin.x = this.mouse.x
      this.mouseOrigin.y = this.mouse.y
      this.isMouseDown = true

      this.controllerImg.setAlpha(1)
    })
    this.moveSensorImg.on('pointermove', (pointer, localX, localY, event) => {
      if (this.isMouseDown) {
        this.mouse.x = this.toWorldX(localX)
        this.mouse.y = this.toWorldY(localY)
      }
    })
    this.moveSensorImg.on('pointerup', (pointer, localX, localY, event) => {
      this.isMouseDown = false
      this.controllerImg.setAlpha(0.8)

      this.player.keyLeft.isDown = false
      this.player.keyRight.isDown = false
      this.player.keyUp.isDown = false
      this.player.keyDown.isDown = false
    })

    const resize = () => {
      if (this.scene) {
        this.x = 10 - (this.scene.scale.width - 1280) / 2
        this.y = 710 + (this.scene.scale.height - 720)
      }
    }
    this.scene.scale.on('resize', resize)
  }

  toWorldX (x) {
    return (this.moveSensorImg.x - this.moveSensorImg.width / 2) + (x * this.moveSensorImg.width)
  }

  toWorldY (y) {
    return (this.moveSensorImg.y - this.moveSensorImg.height / 2) + (y * this.moveSensorImg.height)
  }

  update (time, delta) {
    if (this.isMouseDown) {
      this.prevMove.x = this.move.x
      this.prevMove.y = this.move.y

      this.controllerImg.x = this.mouse.x
      this.controllerImg.y = this.mouse.y

      this.move.x = this.mouse.x - this.mouseOrigin.x
      this.move.y = this.mouse.y - this.mouseOrigin.y

      var dir = new Phaser.Math.Vector2(this.move.x, this.move.y)
      dir.normalize()
      dir.scale(this.move.length() * 5 * (delta / 1000))
      this.mouseOrigin.add(dir)

      this.updateInput()
    } else {
      this.controllerImg.x = CONTROLLER_IMG_POS_X
      this.controllerImg.y = CONTROLLER_IMG_POS_Y
    }
  }

  updateInput () {
    const deadZoneX = Math.abs(this.move.x) > Math.abs(this.prevMove.x) ? DEADZONE_X_START : DEADZONE_X_END

    if (this.move.x < -deadZoneX) {
      this.player.keyLeft.isDown = true
      this.player.keyRight.isDown = false
    } else if (this.move.x > deadZoneX) {
      this.player.keyLeft.isDown = false
      this.player.keyRight.isDown = true
    } else {
      this.player.keyLeft.isDown = false
      this.player.keyRight.isDown = false
    }

    this.player.keyDown.isDown = this.player.keyLeft.isDown || this.player.keyRight.isDown
  }
}
